import * as RICH_TEXT_TYPES from '@contentful/rich-text-types';
export { RICH_TEXT_TYPES };
